/* eslint-disable react/react-in-jsx-scope */
import HomePage from 'pages/Home/HomePage';
import {
  ACCEUIL_PATH,
  ARCHIVE_PATH,
  CLIENT,
  DEPENSE,
  DESACTIVES_PATH,
  DETAIL_CLIENTS_PATH,
  DETAIL_FOURNISSEURS_PATH,
  DOSSIER_PATH,
  FOURNISSEURS,
  // PARAMETRE_PATH,
  PRODUCTS_PATH,
  SOLDES,
  VENTE,
  COMPTABILITE,
  SAISIE_MANUELLE,
  FISCALITE,
  RAPPROCHEMENT_PIECES,
  PLAN_COMPTABLE,
  ASSISTANT_IA,
  ASSISTANT_IA_OPERATION,
  DETTE_PATH,
  CREDIT_PATH,
  PARTAGE_DOSSIER,
  JOURNAL_ACTIVITE,
  MIGRATION_ODOO,
  FACTURATION,
  PIECES_COMPTABLES,
  // AJOUTE_VENTE
} from '../navigationPaths';
import RequireAuth from 'layouts/RequireAuth';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import DashboardAppShell from 'layouts/AppShells/DashboardAppShell';
// import { Outlet } from "react-router-dom";
import ForderListPage from 'pages/ForderPage/ForderListPage';
import { Navigate } from 'react-router-dom';
import DashboardAppShellClient from 'layouts/AppShells/DashboardAppShellClient';
import Accueil from 'pagesDossierClient/accueil/accueil';
import DosierDesactivePage from 'pages/Desactives/DosierDesactivePage';
import DossierArchivePage from 'pages/DossierArchive/DossierArchivePage';
// import DossierActifPage from "pages/DossierActif/DossierActifPage";
import ParametrePage from 'pages/Parametre/ParametrePage';
import ClientPage from 'pagesDossierClient/Client/ClientPage';
import Fournisseurs from 'pagesDossierClient/fournisseurs/fournisseurs';
import DetailFournisseurs from 'pagesDossierClient/fournisseurs/detailFournisseurs';
import DepensesPage from 'pagesDossierClient/depenses/DepensesPage';
import VentePage from 'pagesDossierClient/ventes/Vente';
// import AjoutVente from 'pagesDossierClient/ventes/AjoutVente';
import AddDepensesForm from 'components/AddDepenses/AddDepensesForm';
import AddVenteForm from 'pagesDossierClient/ventes/AddVenteForm/AddVenteForm';
import DepenseDetail from 'pagesDossierClient/depenses/DepenseDetail';
import DetailModifPage from 'pagesDossierClient/ventes/detailModifVente';
import TransactionPage from 'pagesDossierClient/transactions/TransactionPage';
import TransactionDetails from 'pagesDossierClient/transactions/TransactionDetail';
import Facture from 'pagesDossierClient/facture/facture';
import DetailFacture from 'pagesDossierClient/facture/DetailFacture';
import PartageDossier from 'pagesDossierClient/partage/PartageDossier';
import JournalPage from 'pagesDossierClient/journal/JournalPage';
import ClientDetails from 'pagesDossierClient/Client/ClientDetails';
//import Balance from 'pagesDossierClient/balance/Balance';
import ComptabilitePage from 'pagesDossierClient/comptabilite/ComptabilitePage';
import SaisieManuellePage from 'pagesDossierClient/comptabilite/SaisieManuellePage';
// import DetteForm from 'pages/Dette/DetteForm';
import Credit_Dette from 'pages/Dette/CreditForm';
import AddRapprochementForm from 'components/Rapprochement/AddRapprochementForm';
import ComptePaiements from 'pagesDossierClient/comptePaiement/ComptePaiements';
import CreancePage from 'pagesDossierClient/creances/Creance';
import AssistantIAPage from 'pagesDossierClient/assistantIA/AssistantIAPage';
import AssistantIADetailPage from 'pagesDossierClient/assistantIA/AssistantIADetailPage';
import MigrationOdooPage from 'pagesDossierClient/migrationOdoo/MigrationOdooPage';
import FacturationPage from 'pagesDossierClient/facturation/FacturationPage';
import FiscalitePage from 'pagesDossierClient/fiscalite/FiscalitePage';
import RapprochementPage from 'pagesDossierClient/pieces/RapprochementPage';
import PiecesPage from 'pagesDossierClient/pieces/PiecesPage';
import DetailCreancePage from 'pagesDossierClient/creances/DetailCreancePage';
import PayCreanceForm from 'pagesDossierClient/creances/PayCreanceForm';
import DettePage from 'pagesDossierClient/dettes/DettePage';
import DetailDettePage from 'pagesDossierClient/dettes/DetailDettePage';
import PayDetteForm from 'pagesDossierClient/dettes/PayDetteForm';
// import { Navigate } from "react-router-dom";




export const privateRoutes = [
 
  {
    path: ACCEUIL_PATH,
    errorElement: <ErrorBoundary />,

    element: <RequireAuth />,
    children: [
      {
        path: '*',
        element: <Navigate to={ACCEUIL_PATH} />,
      },
      {
        path: '',
        element: <DashboardAppShell />,
        children: [
          {
            path: '',
            element: <HomePage />,
          },
          {
            path: PRODUCTS_PATH,
            element: <ForderListPage />,
            children: [
              {
                path: '',
                element: <ForderListPage />,
              },
              {
                path: ':produitId',
                element: <p>Vous venez d&apos;ajouter un produit</p>,
              },
            ],
          },
          {
            path: DESACTIVES_PATH,
            element: <DosierDesactivePage />,
          },
          {
            path: ARCHIVE_PATH,
            element: <DossierArchivePage />,
          },
        ],
      },
      {
        path: DOSSIER_PATH,
        element: <DashboardAppShellClient />,
        children: [
          {
            path: SOLDES,
            element: <Accueil />,
          },
          {
            path: FOURNISSEURS,
            element: <Fournisseurs />,
          },
          {
            path: `${FOURNISSEURS}details/${DETAIL_FOURNISSEURS_PATH}`,
            element: <DetailFournisseurs />,
          },
          {
            path: CLIENT,
            element: <ClientPage />,
          },
          {
            path: `${CLIENT}details/${DETAIL_CLIENTS_PATH}`,
            element: <ClientDetails />,
          },
          {
            path: DEPENSE,
            element: <DepensesPage />,
          },
          {
            path: VENTE,
            element: <VentePage />,
          },
          {
            path: 'ventes/add-vente',
            element: <AddVenteForm />,
          },
          {
            path: `ventes/:id`,
            element: <DetailModifPage />,
          },
          {
            path: `depenses/add-depense`,
            element: <AddDepensesForm />,
          },
          {
            path: `rapprochement/add-rapprochement`,
            element: <AddRapprochementForm/>,
          },
          {
            path: `depenses/detailDepense/:id`,
            element: <DepenseDetail />,
          },
          {
            path: 'transactions',
            element: <TransactionPage />,
          },
          {
            path: 'creances',
            element: <CreancePage />,
          },
          {
            path: 'creances/paiement-creance',
            element: <PayCreanceForm />,
          },
           {
            path: `creances/:id`,
            element: <DetailCreancePage />,
          },
          {
            path: COMPTABILITE,
            element: <ComptabilitePage />
          },
          {
            path: SAISIE_MANUELLE,
            element: <SaisieManuellePage />
          },
          {
            path: FISCALITE,
            element: <FiscalitePage />
          },
          {
            path: RAPPROCHEMENT_PIECES,
            element: <RapprochementPage />
          },
          {
            path: PLAN_COMPTABLE,
            element: <ComptabilitePage />
          },
          {
            path: ASSISTANT_IA,
            element: <AssistantIAPage />
          },
          {
            path: ASSISTANT_IA_OPERATION,
            element: <AssistantIADetailPage />
          },
          {
            path: 'transactions/:type/:id',
            element: <TransactionDetails />,
          },
          {
            path: 'parametre/',
            element: <ParametrePage />,
          },
          {
            path: DETTE_PATH,
            element: <DettePage />,
          },
          {
            path: `dettes/:id`,
            element: <DetailDettePage />,
          },
          {
            path: 'dettes/paiement-dette',
            element: <PayDetteForm />,
          },
          {
            path: CREDIT_PATH,
            element: <Credit_Dette />,
          },
          {
            path: "compte_paiement/",
            element: <ComptePaiements />,
          },
          {
            path: 'facture/',
            element: <Facture />,
          },
          {
            path: 'facture/:id',
            element: <DetailFacture />,
          },
          {
            path: PARTAGE_DOSSIER,
            element: <PartageDossier />,
          },
          {
            path: JOURNAL_ACTIVITE,
            element: <JournalPage />,
          },
          {
            path: MIGRATION_ODOO,
            element: <MigrationOdooPage />,
          },
          {
            path: FACTURATION,
            element: <FacturationPage />,
          },
          {
            path: PIECES_COMPTABLES,
            element: <PiecesPage />,
          },
        ],
      },
      {
        path: '/nope',
        element: <p>Page vide</p>,
      },
    ],
  },
];
